var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEditIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_4510",
    "data-name": "Group 4510",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.387,
    height: 16.347,
    viewBox: "0 0 16.387 16.347",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_4227",
    "data-name": "Path 4227",
    d: "M0,72.117V75.97H3.853l9.517-9.517L9.477,62.64Z",
    transform: "translate(0 -59.623)",
    fill: "#505465"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4228",
    "data-name": "Path 4228",
    d: "M220.7,4.154a1.03,1.03,0,0,0,0-1.454L218.3.3a1.03,1.03,0,0,0-1.454,0l-1.88,1.88,3.853,3.853,1.88-1.88Z",
    transform: "translate(-204.616)",
    fill: "#505465"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/Edit-icon.f77673937d4efe837dccffbf4fbb8a23.svg";
export { ForwardRef as ReactComponent };